export const rightSidebarTabStorageKey = 'rightSidebarTabName';
export const rightSidebarTabStorageValue = 'chat';

export const rightSidebarVisibilityStorageKey = 'rightSidebarVisibility';
